<template>
    <div class="popup account-dialog account-dialog--profile" :class="classObj" v-if="isLogin">
        <van-popup :value="show" @click-overlay="close" @open="open">
            <div class="content">
                <div class="header">
                    <div><AccountUiIcon name="user" /><span>{{ $t("MyProfile.Profile") }}</span></div>
                    <div class="close">
                        <AccountUiIcon name="close" @click.native="close" />
                    </div>
                </div>
                <div class="user_content">
                    <div class="user_box">
                        <div class="vip_img" v-if="userInfo.levelDetailVo">
                            <img v-theme-art="userInfo.levelDetailVo.memberLevelIcon" :src="userInfo.levelDetailVo.memberLevelIcon" alt="">
                        </div>
                        <div class="user_info">
                            <div class="avatar">
                                <img v-theme-art="$themeImage('person.avatar')" :src="$themeImage('person.avatar')">
                            </div>
                            <div class="user">
                                <div class="phone-label">{{ $t("Setting.PhoneNumber") }}</div>
                                <div class="phone">{{ userPhone }}</div>
                                <div>
                                    {{ $t("MyProfile.ID") }}: {{ userInfo.id }}
                                    <AccountUiIcon class="account-copy" name="copy" @click.native="copyText(userInfo.id)" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="user_account">
                        <div>
                            <AccountUiIcon name="calendar" /><div>{{ $t("MyProfile.Join") }}</div>
                            <div>{{ registerTime }}</div>
                        </div>
                        <div>
                            <AccountUiIcon name="game" /><div>{{ $t("MyProfile.TotalBet") }}</div>
                            <div>
                                {{ formatCurrency(userInfo.grandTotalBetting || 0) }}
                            </div>
                        </div>
                        <div>
                            <AccountUiIcon name="gift" /><div>{{ $t("MyProfile.TotalBonus") }}</div>
                            <div>
                                {{ formatCurrency(userInfo.grandTotalBouns || 0) }}
                            </div>
                        </div>
                    </div>
                    <div class="fav_games">
                        <div class="title">{{ $t("MyProfile.FavoriteGames") }}</div>
                        <van-list v-model="favGame.isLoading" :finished="!favGame.hasMore" loading-text=""
                            @load="getFavList" class="game_list" offset="50" :immediate-check=false
                            v-if="favGame.favList.length !== 0">
                            <div class="game_item" v-for="(item, index) in favGame.favList" :key="item.id">
                                <div class="game_img">
                                    <div class="game_mask">
                                        <!-- <div class="RTP">
                                            <span>RTP</span>
                                            <span>{{ item.rtp }}%</span>
                                        </div> -->
                                        <div class="game_center">
                                            <div class="name">{{ item.gameName }}</div>
                                            <div class="game_btn" @click.stop="onShowGamePopup(item)">
                                                <i class="iconfont icon-shipin"></i>
                                                <span>{{ $t("lang.Play") }}</span>
                                            </div>
                                        </div>
                                        <div class="game_collect" @click.stop="addCollect(item, index)">
                                            <i v-if="activeIds.includes(item.id)"
                                                class="iconAct iconfont icon-a-shoucangyishoucang"></i>
                                            <i v-else class="iconfont icon-a-shoucang_quxiaoshoucang"></i>
                                        </div>
                                    </div>
                                    <img v-theme-art="item.imageUrl" :src="item.imageUrl" />
                                </div>
                                <div class="gameName">{{ item.gameName }}</div>
                            </div>
                        </van-list>
                        <div class="empty" v-else>
                            <AccountUiIcon name="favorite" />
                            <div>{{ $t("lang.NoData") }}</div>
                        </div>
                        <div v-if="favGame.isLoading && favGame.favList.length" class="loading">
                            <a-spin>
                                <a-icon slot="indicator" type="loading" spin />
                            </a-spin>
                            {{ $t("lang.Loading") }}
                        </div>
                        <div v-if="!favGame.hasMore && favGame.favList.length" class="loading">
                            {{ $t("lang.NoMore") }}
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>
        <gamePop :showPop="isShowGamePop" :info="gamePopInfo" :activeIds="activeIds"
            @activeIdsSplice="activeIds.splice($event, 1)" @activeIdsPush="activeIds.push($event)"
            @close="isShowGamePop = false" @onShowGamePopup="onShowGamePopup">
        </gamePop>
        <gamePopup ref="gamePopup" :params="gameParams"></gamePopup>
    </div>
</template>

<script>
import AccountUiIcon from '@/components/account-dialogs/AccountUiIcon.vue'
import handleCopy from '@/utils/copy.js'
import { Toast } from 'vant'
import gamePop from '@/components/gamePopup/infoPopup'
import gamePopup from '@/components/gamePopup'
import { mapState } from 'vuex'
import {
    getGameCollect,
    getGameAllCollect,
    addFav,
    removeFav
} from '@/api/game'
export default {
    name: 'myProfile',
    components: {
        AccountUiIcon,
        gamePop,
        gamePopup
    },
    data() {
        return {
            favGame: {
                favList: [],
                pageNo: 0,
                pageSize: 9,
                hasMore: true,
                isLoading: false
            },
            activeIds: [],
            gameParams: {
                id: '',
                gameInfoId: '',
                gamePlatformType: '',
                providerType: ''
            },
            isShowGamePop: false,
            gamePopInfo: {},
            registerTime: '',
            firstLoaded: true
        }
    },
    computed: {
        isLogin() {
            return !!this.$store.getters.token
        },
        ...mapState({
            device: state => state.app.device
        }),
        classObj() {
            return {
                mobile: this.device === 'mobile'
            }
        },
        userInfo() {
            return this.$store.getters.userInfo
        },
        userPhone() {
            const phone = this.userInfo && this.userInfo.phone
            return phone ? this.maskNumber(phone) : ''
        },
        show: {
            get() {
                return this.$store.getters.isShowMyProfilePopup
            },
            set(val) {
                return val
            }
        }
    },
    created() { },
    methods: {
        close() {
            this.$store.dispatch('user/setIsShowMyProfilePopup', false)
        },
        open() {
            if (this.firstLoaded) {
                this.init()
            }
        },
        init() {
            this.getFavList()
            this.getGameFavs()
            if (this.userInfo) {
                this.registerTime = this.userInfo.registerTime.slice(0, -8)
            }
        },
        maskNumber(phoneNumber) {
            const str = phoneNumber.toString()
            if (str.length <= 4) {
                return str
            }
            const firstTwo = str.slice(0, 2)
            const lastTwo = str.slice(-2)
            return `${firstTwo}***${lastTwo}`
        },
        getFavList() {
            if (!this.favGame.hasMore && this.favGame.isLoading) { return }
            this.isLoading = true
            this.favGame.pageNo++
            const params = {
                pageNo: this.favGame.pageNo,
                pageSize: this.favGame.pageSize
            }
            getGameCollect(params).then((res) => {
                const {
                    result,
                    code
                } = res
                if (code) return
                const {
                    list,
                    total
                } = result
                this.favGame.favList = [...this.favGame.favList, ...list]
                this.favGame.hasMore = Number(total) > this.favGame.favList.length
                this.favGame.isLoading = false
            })
            this.firstLoaded = false
        },
        getGameFavs() {
            getGameAllCollect().then((res) => {
                if (res.code) return
                this.activeIds = res.result
            })
        },
        async addCollect(item) {
            if (!this.isDebounced) {
                this.isDebounced = true
                const that = this
                if (that.activeIds.includes(item.id)) {
                    const index = that.activeIds.indexOf(item.id)
                    if (index !== -1) {
                        await removeFav({
                            id: item.id
                        })
                            .then((res) => {
                                if (res.code === 0) {
                                    that.activeIds.splice(index, 1)
                                    Toast(that.$t('home.CollectionCanceled'))
                                }
                            })
                    }
                } else {
                    await addFav({
                        id: item.id
                    })
                        .then((res) => {
                            if (res.code === 0) {
                                that.activeIds.push(item.id)
                                Toast(that.$t('home.CollectionSucc'))
                            }
                        })
                }
                setTimeout(() => {
                    this.isDebounced = false
                }, 500)
            } else {
                console.log('111')
            }
        },
        openGamePop(item) {
            if (!this.classObj.mobile) {
                this.isShowGamePop = false
            } else {
                this.gamePopInfo = item
                this.isShowGamePop = true
            }
        },
        onShowGamePopup(item) {
            if (this.userInfo && this.userInfo.firstRechargeState === 'No' && this.userInfo.memberType !== 'virtually') {
                this.$store.dispatch('system/setIsShowPlayGamePopup', true)
                return
            }
            if (item.providerType === 'Self' && item.gamePlatformType === 'SelfRaspa') {
                this.onNavToByIsLogin({ url: '/scratchCards', type: 'get', params: { id: item.gameId } })
                return
            }
            this.onNavToByIsLogin({}).then(() => {
                this.gameParams = {
                    id: item.gameId,
                    gameInfoId: item.id,
                    gamePlatformType: item.gamePlatformType,
                    providerType: item.providerType
                }
                this.$refs.gamePopup.open()
            })
        },
        copyText(content) {
            handleCopy(
                {
                    content,
                    success: (msg) => {
                        Toast(msg)
                    },
                    error: (msg) => {
                        Toast(msg)
                    }
                },
                this
            )
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/account-dialogs.scss';
</style>
